import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

import { PROCESS_TYPE } from '../constants/constants';

const SUBMIT_MESSAGES = strings.sendoutsV2.alerts.submitMessages;

const buildUpdateSendoutDetailsAlert = ({ severity, body }) => ({
  severity,
  title: strings.formatString(SUBMIT_MESSAGES[severity].title, {
    processType: PROCESS_TYPE.Sendout.title,
    action:
      severity === 'success' ? SUBMIT_MESSAGES.actions.updated : SUBMIT_MESSAGES.actions.updating
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const updateSendoutDetails = async ({ sendoutId, payload }) => {
  try {
    const response = await API.patch(`${Endpoints.Sendouts}/${sendoutId}`, payload, {
      apiVersion: 2
    });

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildUpdateSendoutDetailsAlert({
          severity: 'error',
          body: strings.formatString(SUBMIT_MESSAGES.unexpectedStatus, { status: response.status })
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildUpdateSendoutDetailsAlert({
        severity: 'success'
      })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildUpdateSendoutDetailsAlert({
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title)
      })
    };
  }
};
